import { AppData, Colors, Lightning } from '@lightningjs/sdk';
import { HoverableComponent } from 'components/common/HoverableComponent';

export default class Boundary extends HoverableComponent<Lightning.Component.TemplateSpec> {
  private _boundaryHoverHandler: ((adjustIndex: number) => void) | null = null;
  private _boundaryUnhoverHandle: (() => void) | null = null;

  set boundaryHoverHandler(handler: ((adjustIndex: number) => void) | null) {
    this._boundaryHoverHandler = handler;
  }

  set boundaryUnhoverHandler(handler: (() => void) | null) {
    this._boundaryUnhoverHandle = handler;
  }

  static override _template() {
    return {
      rect: true,
      color: Colors('transparent').get(),
    };
  }

  override _handleHover() {
    if (!AppData?.device.hoverDisabled() && this._boundaryHoverHandler) {
      const adjustIndex = this.ref === 'BoundaryLeft' ? -1 : +1;
      this._boundaryHoverHandler(adjustIndex);
    }

    return true;
  }

  override _handleUnhover(): boolean {
    if (!AppData?.device.hoverDisabled() && this._boundaryUnhoverHandle) {
      this._boundaryUnhoverHandle();
    }

    return true;
  }
}
